/**
 * stripMarkdown — remove Markdown syntax before passing text to TTS.
 *
 * Handles: code blocks, inline code, headings, bold/italic (** __ * _),
 * links, images, blockquotes, horizontal rules, list bullets, tables.
 * Keeps the plain words so the TTS reads naturally.
 */
export function stripMarkdown(text) {
  if (!text) return '';

  return text
    // ── Code blocks (``` … ```) — drop entirely, code is not speakable ──────
    .replace(/```[\s\S]*?```/g, '')

    // ── Inline code (`…`) — keep the content, drop backticks ────────────────
    .replace(/`([^`]+)`/g, '$1')

    // ── Headings (# ## ### …) ───────────────────────────────────────────────
    .replace(/^#{1,6}\s+/gm, '')

    // ── Bold + italic (***…*** / ___…___) ───────────────────────────────────
    .replace(/\*{3}([^*\n]+)\*{3}/g, '$1')
    .replace(/_{3}([^_\n]+)_{3}/g, '$1')

    // ── Bold (**…** / __…__) ────────────────────────────────────────────────
    .replace(/\*{2}([^*\n]+)\*{2}/g, '$1')
    .replace(/_{2}([^_\n]+)_{2}/g, '$1')

    // ── Italic (*…* / _…_) — only when surrounding a word (avoids false hits) ─
    .replace(/\*([^*\n]+)\*/g, '$1')
    .replace(/_([^_\n]+)_/g, '$1')

    // ── Strikethrough (~~…~~) ────────────────────────────────────────────────
    .replace(/~~([^~\n]+)~~/g, '$1')

    // ── Images (![alt](url)) — speak the alt text ───────────────────────────
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1')

    // ── Links ([text](url)) — speak the link text ───────────────────────────
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')

    // ── Blockquotes (> …) ───────────────────────────────────────────────────
    .replace(/^>\s*/gm, '')

    // ── Horizontal rules (--- / *** / ___) ──────────────────────────────────
    .replace(/^[-*_]{3,}\s*$/gm, '')

    // ── Unordered list bullets (- / * / +) ──────────────────────────────────
    .replace(/^[ \t]*[-*+]\s+/gm, '')

    // ── Ordered list markers (1. / 2. …) ────────────────────────────────────
    .replace(/^[ \t]*\d+\.\s+/gm, '')

    // ── Table pipes and separator rows ──────────────────────────────────────
    .replace(/\|/g, ' ')
    .replace(/^[\s:|-]+$/gm, '')

    // ── HTML tags (e.g. <br>, <strong>) ─────────────────────────────────────
    .replace(/<[^>]+>/g, '')

    // ── Tidy up: collapse 3+ blank lines to 2, trim ─────────────────────────
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
